<div class="table-container">
  <p-table
    [value]="data()"
    [scrollable]="true"
    [loading]="loading()"
    class="p-table-fixed">
    <ng-template #header>
      <tr>
        <th class="cursor-pointer w-[20rem]">
          Grupo empresarial
        </th>
        <th class="cursor-pointer w-[10rem]">
          <app-sort-header
            columnName="Nombre"
            columnKey="Name"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Name')"
          />
        </th>
        <th class="cursor-pointer w-[10rem]">
          <app-sort-header
            columnName="Apellido"
            columnKey="LastName"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('LastName')"
          />
        </th>
        <th class="cursor-pointer w-[20rem]">
          <app-sort-header
            columnName="Correo electrónico"
            columnKey="Email"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Email')"
          />
        </th>
        <th class="cursor-pointer w-[10rem]">
          <app-sort-header
            columnName="Teléfono"
            columnKey="Phone"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Phone')"
          />
        </th>
        <th class="cursor-pointer w-[20rem]">
          <app-sort-header
            columnName="Empresa(s)"
            columnKey="Businesses"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Businesses')"
          />
        </th>
        <th class="cursor-pointer w-[8rem]">
          <app-sort-header
            columnName="Estado"
            columnKey="Status"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Status')"
          />
        </th>
        @if(UserRole.BUSSINESSMEN | notHasRole){
          <th class="w-[8rem]" pFrozenColumn alignFrozen="right">Acciones</th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-user>
      <tr>
        <td>
          <app-business-logo
            [logoUrl]="user.BusinessGroupUrl"
            [name]="user.BusinessGroupName || 'Sin grupo'"
          />
        </td>
        <td>{{ user.Name }}</td>
        <td>{{ user.LastName }}</td>
        <td>{{ user.Email }}</td>
        <td>{{ user.Phone }}</td>
        <td>{{ user.Businesses || 'Admin' }}</td>
        <td>{{ user.Status === 'ENABLED' ? 'Activo' : 'Inactivo' }}</td>
        @if(UserRole.BUSSINESSMEN | notHasRole){
          <td pFrozenColumn alignFrozen="right">
            <p-button type="button" variant="text" (onClick)="displayRowActions($event, user)">
              <span class="material-symbols-outlined cursor-pointer"> more_vert </span>
            </p-button>
          </td>
        }
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="8">No se encontraron resultados</td>
      </tr>
    </ng-template>
  </p-table>

  <app-paginator
    [first]="first()"
    [rows]="rows()"
    [totalRecords]="totalRecords()"
    (pageChange)="pageChange.emit($event)"
  />

  <p-popover #popover (onHide)="selectedUser = null">
    <ng-template #content>
      <div class="flex flex-col gap-4">
        <ul class="list-none p-0 m-0 flex flex-col">
          @for (action of actionsOptions; track $index) {
          <li class="flex items-center gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border"
            (click)="selectOption(action)">
            <span class="font-medium">{{ action.label }}</span>
          </li>
          }
        </ul>
      </div>
    </ng-template>
  </p-popover>
</div>
